<template>
    <div class="ticket-stack__item-status">
        <i
            v-if="liveIndicator"
            class="ticket-stack__item-status-live icon icon-dot_circle"
        />
        <div
            v-if="[TicketStatus.win, TicketStatus.lost, TicketStatus.canceled, TicketStatus.refund].includes(status)"
            :class="style.mask"
        >
            <i :class="style.icon" />
        </div>
        <div
            v-else
            class="ticket-stack__item-status-icon"
        >
            <span class="status__events-left">{{ numEventsLeft }}</span>
        </div>
    </div>
</template>

<script>
    import { TicketStatus } from '@models/tickets/enums';

    export default {
        name: 'Status',
        props: {
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                default: 0
            },
            liveIndicator: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        created() {
            this.TicketStatus = TicketStatus;
        },
        computed: {
            style() {
                const maskClassNames = ['ticket-stack__item-status-icon'];
                const iconClassNames = ['icon'];
                switch (this.status) {
                    case TicketStatus.win:
                        maskClassNames.push('won');
                        iconClassNames.push('icon-check_circle_filled');
                        break;
                    case TicketStatus.lost:
                        iconClassNames.push('icon-close_circle_filled');
                        maskClassNames.push('lost');
                        break;
                    case TicketStatus.refund:
                        iconClassNames.push('icon-refresh_circle_filled');
                        maskClassNames.push('refund');
                        break;
                    case TicketStatus.canceled:
                        iconClassNames.push('icon-close_circle_filled');
                        maskClassNames.push('canceled');
                        break;
                    default:
                        break;
                }
                return {
                    mask: maskClassNames,
                    icon: iconClassNames,
                };
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/tickets/Status.vue